import { FeatureLogger } from '../../utils/feature-logger';

const name = 'traffic-source-tracking';

export const logger = new FeatureLogger(name);
